import React, { memo } from 'react'
import { useSelector } from 'react-redux'
import FilterCategory from './filter_category'
import FilterBrand from './filter_brand'
import FilterSpec from './filter_spec'
import FilterPrice from './filter_price'
import FilterOptionAll from './filter_option_all'

const FilterGroup = () => {
    const setSearchDataOption = useSelector(state => state.initial.setSearchDataOption)
    const filterOptionAll = useSelector(state => state.initial.filterOptionAll)
    const categoryData = useSelector(state => state.category.categoryData)
    const currentCategory = useSelector(state => state.category.currentCategory)
    const { makerList, specList } = setSearchDataOption

    return (
        <>
            {setSearchDataOption.makerList && (
                <>
                    {(categoryData.length > 0 && currentCategory.reduce) && <FilterCategory />}
                    {makerList.length > 0 && <FilterBrand makerList={makerList} />}
                    {specList.map((v, i) => {
                        const length = filterOptionAll ? specList.length : 3
                        return length >= i && <FilterSpec key={v.pr_idx} specData={v} />
                    })}
                    <FilterPrice />
                    <FilterOptionAll />
                </>
            )}
        </>
    )
}

export default memo(FilterGroup)



// WEBPACK FOOTER //
// ./src/estimate_list/components/filter/filter_group.js